var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"d-flex align-start pt-7 grey--text text--darken-3"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }